import * as z from "zod/v4";
import { GetUser } from "./user";

export interface Install {
  auth_url: string;
}

export interface AuthResponse {
  authToken: string;
  user: GetUser;
  installationURL?: string;
  url?: string;
}

export enum ShopifyExchangeOrderStrategy {
  ORDER = "order",
  RETURN = "return",
}

export enum ShopifyExchangePaymentStrategy {
  DRAFT_ORDER = "draft_order",
  STRIPE = "stripe",
}

export interface ShopifyIntegration {
  exchangeOrderStrategy: ShopifyExchangeOrderStrategy;
  checkoutOutboundRatesEnabled: boolean;
  hasShopifyPlus: boolean | undefined;
  planDisplayName: string | undefined;
  refreshToken?: string | undefined;
  accessTokenExpiresAt?: Date | undefined;
  refreshTokenExpiresAt?: Date | undefined;
}

export enum InstallSource {
  MAIN_APP = "main",
  /**
   * Originally the "Order Tracking" Shopify app; now repurposed as the "Recover" app.
   * The string value is kept as "order_tracking" for backward compatibility.
   * Enum name still contains the string ORDER_TRACKING_APP so that it shows up when grepping
   * for related environment variables.
   */
  ORDER_TRACKING_APP_BUT_ACTUALLY_RECOVER = "order_tracking",
  RECLAIM_APP = "reclaim",
}

export const installSourceSchema = z.enum(InstallSource);
